// ** ThemeConfig Import
import themeConfig from '@configs/themeConfig';

// ** Returns Initial Menu Collapsed State
const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem('menuCollapsed');
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed;
};

// ** Initial State
const initialState = {
  isRTL: themeConfig.layout.isRTL,
  menuCollapsed: initialMenuCollapsed(),
  menuHidden: themeConfig.layout.menu.isHidden,
  menuPinner: themeConfig.layout.menu.isPinner,
  contentWidth: themeConfig.layout.contentWidth
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE_CONTENT_WIDTH':
      return { ...state, contentWidth: action.payload };
    case 'HANDLE_MENU_COLLAPSED':
      window.localStorage.setItem('menuCollapsed', action.payload);
      return { ...state, menuCollapsed: action.payload };
    case 'HANDLE_MENU_HIDDEN':
      return { ...state, menuHidden: action.payload };
    case 'HANDLE_MENU_PINNER':
      return { ...state, menuPinner: action.payload };
    case 'HANDLE_RTL':
      return { ...state, isRTL: action.payload };
    default:
      return state;
  }
};

export default layoutReducer;
